'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    '3g2': 'video/3gpp2',
    '3gp': 'video/3gpp',
    ai: 'application/postscript',
    asc: 'text/plain',
    avi: 'video/avi',
    bmp: 'image/bmp',
    css: 'text/css',
    csv: 'text/csv',
    diff: 'text/plain',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dot: 'application/msword',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    eps: 'application/postscript',
    exe: 'application/octet-stream',
    flv: 'video/x-flv',
    gif: 'image/gif',
    htm: 'text/html',
    html: 'text/html',
    jpe: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    js: 'application/x-javascript',
    json: 'application/json',
    log: 'text/plain',
    m2v: 'video/mpeg',
    m4a: 'audio/mp4',
    m4v: 'video/x-m4v',
    mov: 'video/quicktime',
    mp2: 'audio/mpeg',
    mp3: 'audio/mpeg',
    mp4: 'video/mp4',
    mpe: 'video/mpeg',
    mpeg: 'video/mpeg',
    mpega: 'audio/mpeg',
    mpg: 'video/mpeg',
    mpga: 'audio/mpeg',
    otf: 'application/vnd.oasis.opendocument.formula-template',
    pdf: 'application/pdf',
    pgp: 'application/pgp-signature',
    png: 'image/png',
    pot: 'application/vnd.ms-powerpoint',
    potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
    pps: 'application/vnd.ms-powerpoint',
    ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ps: 'application/postscript',
    psd: 'image/photoshop',
    qt: 'video/quicktime',
    rtf: 'text/rtf',
    rv: 'video/vnd.rn-realvideo',
    svg: 'image/svg+xml',
    svgz: 'image/svg+xml',
    swf: 'application/x-shockwave-flash',
    swfl: 'application/x-shockwave-flash',
    text: 'text/plain',
    tif: 'image/tiff',
    tiff: 'image/tiff',
    txt: 'text/plain',
    wav: 'audio/x-wav',
    webm: 'video/webm',
    wmv: 'video/x-ms-wmv',
    xhtml: 'text/html',
    xlb: 'application/vnd.ms-excel',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-upload/lib/runtime/mime.js
// module id = 497
// module chunks = 0